/**
 * @file コンポーネント：フル動画ページ利用規約モーダル ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalTermsVideo = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
